// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cx from 'classnames';
import Expandable from 'shared/containers/Expandable';
import Icon from 'shared/components/Icon';
import NumberBadge from './NumberBadge';

const NavLink = ({ path, label }, context) => (
  <li className={context.router.isActive(path) ? 'active' : ''}>
    <Link to={path}>{label}</Link>
  </li>
);

NavLink.displayName = 'Submenu.NavLink';
NavLink.contextTypes = { router: PropTypes.object };

const NavFakeLink = ({ onClick, label }) => (
  <li>
    <span className="fake-link" onClick={onClick}>
      {label}
    </span>
  </li>
);

NavFakeLink.displayName = 'Submenu.NavFakeLink';

const NavOldLink = ({ path, label }, context) => (
  <li className={context.router.isActive(path) ? 'active' : ''}>
    <a href={path}>{label}</a>
  </li>
);

NavOldLink.displayName = 'Submenu.NavOldLink';
NavOldLink.contextTypes = { router: PropTypes.object };

class Submenu extends Component {
  constructor(props, state) {
    super(props, state);
    this.hasActiveChild = this.hasActiveChild.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = { isOpen: this.hasActiveChild() };
  }

  hasActiveChild() {
    const { router } = this.context;
    const childrenPaths = React.Children.map(this.props.children, c => c && c.props.path);
    const somePathActive = childrenPaths.some(path => router.isActive(path));
    return somePathActive;
  }

  handleClick() {
    const { onClick } = this.props;
    this.setState({ isOpen: !this.state.isOpen });
    if (onClick) {
      onClick();
    }
  }

  render() {
    const { icon, label, children, numberBadge } = this.props;
    const { isOpen } = this.state;
    const isActive = this.hasActiveChild();

    const classes = cx('submenu', { active: isActive });

    return (
      <li className={classes}>
        {/* TODO: Remove href="#" */}
        <a onClick={this.handleClick}>
          <div className="sidebar-icon">
            <Icon name={icon} />
          </div>
          <span>{label}</span>
          <Icon name="chevron-down" /> {/* TODO: Flip when open */}
          <NumberBadge number={numberBadge} />
        </a>
        <Expandable isOpen={isOpen}>
          <ul>{children}</ul>
        </Expandable>
      </li>
    );
  }
}

Submenu.contextTypes = {
  router: PropTypes.object,
};

Submenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  numberBadge: PropTypes.number,
};

Submenu.defaultProps = {
  isOpen: false,
};

Submenu.NavLink = NavLink;
Submenu.NavFakeLink = NavFakeLink;
Submenu.NavOldLink = NavOldLink;

export default Submenu;
